import { twMerge } from "tailwind-merge";

import { ContentType } from "../../lib/__generated__/graphql";
import { ContentLabel } from "../content-label/content-label";

export type SearchItem = {
  type: ContentType;
  title: string;
  description?: string;
  authors?: string[];
};

type Props = SearchItem & {
  className?: string;
  onClick?: () => void;
};

export const SearchItem = ({
  type,
  title,
  description,
  className = "",
}: Props) => {
  return (
    <div
      data-component="SearchItem"
      className={twMerge(
        "gap-1 plh-flex plh-flex-col plh-px-4 plh-py-3",
        className,
      )}
    >
      <ContentLabel type={type} />
      <h3 className="plh-line-clamp-2 plh-overflow-ellipsis plh-font-quicksand plh-text-h5 plh-text-blue-500 plh-text-grey-10">
        {title}
      </h3>
      {description && (
        <p className="plh-text-roboto plh-line-clamp-1 plh-overflow-ellipsis plh-text-caption plh-text-grey-2">
          {description}
        </p>
      )}
    </div>
  );
};
